"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PRESCRIBER_LIST_MAX_ITEMS () {
        return PRESCRIBER_LIST_MAX_ITEMS;
    },
    get PrescriberListItemSchema () {
        return PrescriberListItemSchema;
    },
    get PrescriberListResponseSchema () {
        return PrescriberListResponseSchema;
    },
    get PrescriberProfileNotSetResponseSchema () {
        return PrescriberProfileNotSetResponseSchema;
    },
    get PrescriberProfileResponseSchema () {
        return PrescriberProfileResponseSchema;
    },
    get PrescriberProfileSaveResponseSchema () {
        return PrescriberProfileSaveResponseSchema;
    },
    get PrescriberProfileSetResponseSchema () {
        return PrescriberProfileSetResponseSchema;
    },
    get PrescriberProfileUpdateRequestSchema () {
        return PrescriberProfileUpdateRequestSchema;
    }
});
const _zod = require("zod");
const _identifiers = require("./identifiers");
const _prescribersnapshot = require("./prescriber-snapshot");
const PRESCRIBER_LIST_MAX_ITEMS = 200;
const PrescriberProfileNotSetResponseSchema = _zod.z.object({
    isSet: _zod.z.literal(false),
    userId: _zod.z.string().uuid(),
    version: _zod.z.literal(0)
}).strict();
/** The stored profile as returned: already normalised, so no transforms. */ const storedProfileShape = {
    printedName: _zod.z.string().min(1),
    specialty: _zod.z.string().min(1).nullable(),
    prcLicenseNo: _zod.z.string().regex(_identifiers.PRC_LICENSE_NO_PATTERN),
    prcExpiresOn: _zod.z.iso.date(),
    ptrNo: _zod.z.string().regex(_identifiers.PRESCRIBER_REFERENCE_NO_PATTERN).nullable(),
    ptrIssuedOn: _zod.z.iso.date().nullable(),
    ptrIssuedPlace: _zod.z.string().min(1).nullable(),
    s2LicenseNo: _zod.z.string().regex(_identifiers.PRESCRIBER_REFERENCE_NO_PATTERN).nullable(),
    s2ExpiresOn: _zod.z.iso.date().nullable()
};
const setResponseShape = {
    isSet: _zod.z.literal(true),
    userId: _zod.z.string().uuid(),
    version: _zod.z.number().int().min(1),
    ...storedProfileShape,
    /**
   * Computed by the server in the clinic's timezone. The licence is valid
   * through its expiry date, so this turns true the day after.
   */ prcExpired: _zod.z.boolean(),
    updatedAt: _zod.z.string().datetime({
        offset: true
    })
};
const PrescriberProfileSetResponseSchema = _zod.z.object(setResponseShape).strict();
const PrescriberProfileResponseSchema = _zod.z.discriminatedUnion('isSet', [
    PrescriberProfileNotSetResponseSchema,
    PrescriberProfileSetResponseSchema
]);
const PrescriberProfileSaveResponseSchema = _zod.z.object({
    ...setResponseShape,
    changedFields: _zod.z.array(_zod.z.enum(_prescribersnapshot.PRESCRIBER_SNAPSHOT_FIELDS))
}).strict();
const PrescriberProfileUpdateRequestSchema = _zod.z.object({
    version: _zod.z.number({
        error: 'version must be a number.'
    }).int({
        error: 'version must be a whole number.'
    }).min(0, {
        error: 'version must not be negative.'
    }),
    ..._prescribersnapshot.prescriberSnapshotShape
}).strict().superRefine(_prescribersnapshot.refinePrescriberGroups);
const PrescriberListItemSchema = _zod.z.object({
    userId: _zod.z.string().uuid(),
    displayName: _zod.z.string().nullable(),
    email: _zod.z.string(),
    status: _zod.z.enum([
        'active',
        'suspended',
        'invited'
    ]),
    isSet: _zod.z.boolean(),
    version: _zod.z.number().int().min(0),
    prcExpiresOn: _zod.z.iso.date().nullable(),
    prcExpired: _zod.z.boolean().nullable()
}).strict();
const PrescriberListResponseSchema = _zod.z.object({
    items: _zod.z.array(PrescriberListItemSchema).max(PRESCRIBER_LIST_MAX_ITEMS)
}).strict();
